import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
@Injectable()
export class AuthGuardWithParams implements CanActivate {
  constructor(
    private router: Router
  ) {
  }

  // eslint-disable-next-line max-len
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const urlQueryParams = Object.keys(route.queryParams);
    const urlParams = Object.keys(route.params);
    if (urlQueryParams.length) {
      const dataQueryParams = route.data.queryParam.split(',');
      let foundAndMatch = dataQueryParams.filter(dataQP => (
        urlQueryParams.length === dataQueryParams.length
        && urlQueryParams.includes(dataQP)
        && route.queryParams?.[dataQP])
      );
      return foundAndMatch.length
        ? true : this.router.navigate([route.data.redirectTo]);
    } else if (urlParams.length) {
      const foundParam = urlParams.find(param => route.params[param]);
      return route.params?.[foundParam]
        ? true : this.router.navigate([route.data.redirectTo]);
    }
    this.router.navigate([route.data.redirectTo]);
  }
}
